import { useTranslation } from 'react-i18next';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  IconButton, 
  Typography, 
  useTheme 
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { CaseHandlerResponseDto } from '@bandido/shared/dtos';

import { Form } from './Form';

interface Props {
  open: boolean;
  agencyId: string;
  onClose: () => void;
  handler?: CaseHandlerResponseDto;
}

export const HandlerModal = ({ open, onClose, agencyId, handler }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const action = handler ? t('caseHandlers.edit.title') : t('caseHandlers.create.title');

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      fullScreen
      scroll="body"
    >
      <DialogTitle 
        sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          pb: 1
        }}
      >
        <Typography variant="h6" component="h2">
          {action}
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="primary" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Form onClose={onClose} agencyId={agencyId} handler={handler} />
      </DialogContent>
    </Dialog>
  );
};
